import React from 'react';
import assets, { accountants } from '../../utils/assets';
import styles from "../../pages/pages.module.scss";
import ButtonShapped from '../ButtonShapped';

const QualifiedAccountantsSection = () => {
  return (
    <section >
      <div className="container">
        <div className={`mb-3 mb-md-5 mx-2 ${styles.sectionheading}`}>
          <ButtonShapped
            text="Qualified Accountants"
            type="primaryshaped"
          ></ButtonShapped>
          <h3>
            AI Enabled <span> Chartered Accountants</span> that actually
            understand Startups and Ecommerce Available to support you 24 X 7
          </h3>
        </div>
      </div>

      <div className={styles.toolaHSec6}>
        <div className="container">
          <div className="row mx-1 mx-sm-3">
            <div className="col-lg-6">
              <p className={`mb-4 ${styles.leftHeading}`}>
                Accounting serves as the Backbone for your growth, Clean books
                give you reliable financial data for better decisions
              </p>
              <div className={styles.cardwrapper}>
                <div className={styles.cardwrapperbody}>
                  {accountants.map((item, index) => (
                    <div className={styles.reportItem} key={index}>
                      <div className="d-flex gap-3 align-items-start">
                        <img
                          src={item.icon}
                          alt={`${item.text} icon`}
                          className="icon"
                        />
                        <div className={styles.detailspart}>
                          <h6>{item.head}</h6>
                          <p>{item.subhead}</p>
                        </div>
                      </div>
                    </div>
                  ))}</div>
              </div>
            </div>

            <div className={`col-lg-1 ${styles.onleftline}`}></div>

            <div className={`col-lg-5 mt-sm-5 mt-5 mt-lg-0  ${styles.rightContent}`}>
              <div className="row ">
                <div className="col-sm-12 text-center">
                  <h5>Work with qualified Chartered Accountants</h5>
                  <div className="d-flex justify-content-center align-items-center">
                    <div className={styles.ripplecontainer}>
                      <img src={assets.caBImg} alt="Centered" className="img-fluid" />
                      <div className={styles.ripple}></div>
                      <div className={styles.ripple}></div>
                    </div>
                  </div>
                  {/* <p>Abhishek, Ex-Deloitte</p> */}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section >
  )
}

export default QualifiedAccountantsSection;